<div class="points-dialog">

    <!-- ENCABEZADO -->

    <header class="points-dialog__header">

        <div class="points-dialog__title">

            <span class="points-dialog__eyebrow">
                BENEFICIO NINA
            </span>

            <h2>
                ¿Quieres usar tus
                <span class="nina-brand-italic">puntos</span>?
            </h2>

        </div>

        <button type="button" class="points-dialog__close" mat-dialog-close aria-label="Cerrar">

            <mat-icon>
                close
            </mat-icon>

        </button>

    </header>


    <!-- CONTENIDO -->

    <mat-dialog-content class="points-dialog__content">

        <!-- ICONO -->

        <div class="points-dialog__icon">
            <mat-icon>
                stars
            </mat-icon>
        </div>


        <!-- PUNTOS DISPONIBLES -->

        <span class="points-dialog__label">
            PUNTOS DISPONIBLES
        </span>

        <div class="points-dialog__amount">

            <strong>
                {{ userPointsData ? userPointsData.puntos : 0 }}
            </strong>

            <span>
                puntos
            </span>

        </div>


        <p class="points-dialog__description">
            Tienes puntos disponibles que puedes utilizar
            para reducir el monto de esta compra.
        </p>


        <!-- VALOR -->

        <div class="points-dialog__value">

            <div class="points-dialog__value-icon">

                <mat-icon>
                    savings
                </mat-icon>

            </div>

            <div class="points-dialog__value-info">

                <span>
                    VALOR DE TUS PUNTOS
                </span>

                <strong>
                    {{
                    userPointsData
                    ? userPointsData.puntos
                    : 0
                    }}
                    MXN
                </strong>

            </div>

            <span class="points-dialog__value-note">
                1 punto = $1 MXN
            </span>

        </div>


        <!-- ACCIONES -->

        <div class="points-dialog__actions">

            <button type="button" class="points-dialog__button points-dialog__button--secondary"
                (click)="dontUsePoints()">

                No, gracias

            </button>


            <button type="button" class="points-dialog__button points-dialog__button--primary"
                (click)="confirmUsePoints()">

                <span>
                    Sí, usar mis puntos
                </span>

                <mat-icon>
                    arrow_forward
                </mat-icon>

            </button>

        </div>

    </mat-dialog-content>

</div>